<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaFiliais"
      :camposTabela="retornaCamposTabela()"
      ordenarPor="codigo"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @clicouItemTabela="clicouItemTabela"
      @limpar="limpar"
    />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      :start-opened="true"
      @cadastroFiliais="cadastroFiliais"
    />
  </div>
</template>

<script>
import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import FiliaisService from '../../services/filiais.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroFiliais',
      icon: 'person_add',
      tooltip: 'Cadastrar filiais',
    },
  ],
}

export default {
  name: 'Filiais',
  components: {
    LayoutTelaFiltros,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaFiliais: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
    }
  },
  created() {
    this.buscarTodos()
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const filiais = await FiliaisService.retornaTodos(pagina)
        this.listaFiliais = filiais.lista
        this.totalDePaginas = filiais.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const filiais = await FiliaisService.retornaTodosPorFiltro(filtro, pagina)
        this.listaFiliais = filiais.lista
        this.totalDePaginas = filiais.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-filiais-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaFiliais = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        codigo: {
          label: 'Código',
        },
        nome: {
          label: 'Nome',
        },
      }
    },
    cadastroFiliais() {
      this.$router.push({ name: 'rota-filiais-cadastro' })
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>
